import { createContext, useContext, type ReactNode } from "react";

import {
  useSystemAudio,
  type SystemAudioStatus,
  type SystemAudioSurface,
} from "./use-system-audio";

type SystemAudioContextValue = {
  status: SystemAudioStatus;
  stream: MediaStream | null;
  surface: SystemAudioSurface;
  connect: () => Promise<void>;
  disconnect: () => void;
};

const SystemAudioContext = createContext<SystemAudioContextValue | null>(null);

export const SystemAudioProvider = ({ children }: { children: ReactNode }) => {
  const value = useSystemAudio();
  return <SystemAudioContext.Provider value={value}>{children}</SystemAudioContext.Provider>;
};

export const useSystemAudioContext = () => {
  const ctx = useContext(SystemAudioContext);
  if (!ctx) throw new Error("useSystemAudioContext must be used within SystemAudioProvider");
  return ctx;
};
